import { emptyGarmentObject, getThisVendorWebsite } from '../Context/GarmentContext/garmentContextFunctions';
import { AllTShirtMeasuresMandatory } from '../types/databaseTables/idealteemeasures';
import { NewTeeTypesRow } from '../types/databaseTables/newteetypes';
import { TeeMeasuresAveragesRow } from '../types/databaseTables/teemeasuresaverages';
import { VendorsRow } from '../types/databaseTables/vendors';
import { GarmentObjectGarmentPage } from '../types/reducers/filterReducer';
import { logAdminExternal } from '../utils/logging';
import { getFitAndReliabilityScores } from './filterReducer';

function getNewGarmentObject({
    thisTeeTypesRow, teeMeasuresArray, vendors, userFitScoreWeights, idealGarmentMeasurements, size
}: {
    thisTeeTypesRow: NewTeeTypesRow | undefined, teeMeasuresArray: TeeMeasuresAveragesRow[], vendors: VendorsRow[],
    userFitScoreWeights: AllTShirtMeasuresMandatory,
    idealGarmentMeasurements: AllTShirtMeasuresMandatory, size: string
}): GarmentObjectGarmentPage {

    if (thisTeeTypesRow === undefined) return emptyGarmentObject;
    // Get all teeMeasureRows associated with this teeType
    const possibleTeeMeasureAveragesRows = teeMeasuresArray.filter(
        (thisRow) => thisRow.newteetypes_id === thisTeeTypesRow.newteetypes_id
    );
    if (possibleTeeMeasureAveragesRows.length === 0) return emptyGarmentObject;
    // Default to first match (in absence of a selected size)
    let thisTeeMeasureAveragesObject = possibleTeeMeasureAveragesRows[0];
    const teeMeasuresRowWithSelectedSize = possibleTeeMeasureAveragesRows.find(thisRow => thisRow.size === size);
    if (teeMeasuresRowWithSelectedSize !== undefined) {
        thisTeeMeasureAveragesObject = teeMeasuresRowWithSelectedSize;
    }
    const vendorsWebsite = getThisVendorWebsite(
        thisTeeTypesRow.manufacturer,
        vendors
    ) || "";

    const fitAndReliabiltyScore = getFitAndReliabilityScores(
        thisTeeMeasureAveragesObject,
        userFitScoreWeights,
        idealGarmentMeasurements
    )

    return { ...thisTeeMeasureAveragesObject, ...thisTeeTypesRow, ...fitAndReliabiltyScore, vendorsWebsite };
}


export interface UpdateGarmentObject {
    type: 'update garment object',
    payload: {
        thisTeeTypesRow: NewTeeTypesRow | undefined,
        teeMeasuresArray: TeeMeasuresAveragesRow[],
        vendors: VendorsRow[],
        userFitScoreWeights: AllTShirtMeasuresMandatory,
        idealGarmentMeasurements: AllTShirtMeasuresMandatory,
        size: string
    },
}

export interface UpdateVendorWebsite {
    type: 'update vendor website',
    payload: {
        vendorsWebsite: string;
    },
}

export type GarmentObjectReducerAction = UpdateGarmentObject | UpdateVendorWebsite;



export function garmentObjectReducer(initialState: GarmentObjectGarmentPage, action: GarmentObjectReducerAction): GarmentObjectGarmentPage {
    let returnState = { ...initialState };
    switch (action.type) {
        case "update garment object": {
            const {
                thisTeeTypesRow,
                teeMeasuresArray,
                vendors,
                userFitScoreWeights,
                idealGarmentMeasurements, size
            } = action.payload;
            returnState = getNewGarmentObject({
                thisTeeTypesRow, teeMeasuresArray, vendors, userFitScoreWeights, idealGarmentMeasurements, size
            })
            break;
        }
        case "update vendor website": {
            returnState.vendorsWebsite = action.payload.vendorsWebsite
            break;
        }
        default:
            logAdminExternal({
                status: "userDetailsReducer returning default value"
            })
            return initialState

    }
    return returnState
}